import Model, { attr } from '@ember-data/model';

export default class ContrasenaModel extends Model {
  @attr('string') keytra;
  @attr('string') coddirectorio;
  @attr('string') fecha;
  @attr('string') serie;
  @attr('number') numero;
  @attr('string') codclasifica;
  @attr('number') diascredito;
  @attr('string') numerodoc;
  @attr('string') observaciones;
}
